"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const ContactUsFooter = () => (react_1.default.createElement("div", { className: 'contact-us-footer' },
    react_1.default.createElement("div", { className: 'email-block' },
        react_1.default.createElement("h5", null, "For any questions related to:"),
        react_1.default.createElement("ul", null,
            react_1.default.createElement("li", null,
                "Press Inquiries and Interview Requests: ",
                react_1.default.createElement("a", { href: 'mailto:press@themlc.com' }, "press@themlc.com ")),
            react_1.default.createElement("li", null,
                "Monthly Usage Reporting: ",
                react_1.default.createElement("a", { href: 'mailto:dsp.relations@themlc.com' }, "dsp.relations@themlc.com ")),
            react_1.default.createElement("li", null,
                "Royalties or Assessment Payments: ",
                react_1.default.createElement("a", { href: 'mailto:finance@themlc.com' }, "finance@themlc.com ")),
            react_1.default.createElement("li", null,
                "Marketing: ",
                react_1.default.createElement("a", { href: 'mailto:marketinginfo@themlc.com' }, "marketinginfo@themlc.com ")),
            react_1.default.createElement("li", null,
                "International Relations: ",
                react_1.default.createElement("a", { href: 'mailto:international@themlc.com' }, "international@themlc.com ")),
            react_1.default.createElement("li", null,
                "Data Quality Initiative (DQI):",
                ' ',
                react_1.default.createElement("a", { href: 'mailto:data.quality@themlc.com' }, "data.quality@themlc.com "))))));
exports.default = ContactUsFooter;
